"use client";

import { c as _c } from "react/compiler-runtime";
import SignInPrompt from "@/features/home-v2/SignInPrompt";
import { useAuthStore } from "@/store/useAuthStore";
import type { Locale } from "@/i18n-config";
export default function GlobalLoginModalWrapper(t0) {
  const $ = _c(4);
  const {
    lang
  } = t0;
  const {
    isLoginModalOpen,
    closeLoginModal
  } = useAuthStore();
  const t1 = lang as "fa" | "en";
  let t2;
  if ($[0] !== closeLoginModal || $[1] !== isLoginModalOpen || $[2] !== t1) {
    t2 = <SignInPrompt open={isLoginModalOpen} onClose={closeLoginModal} lang={t1} />;
    $[0] = closeLoginModal;
    $[1] = isLoginModalOpen;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}